import { Injectable } from '@angular/core';

// import 'rxjs/add/operator/delay';
// 
// import 'rxjs/add/operator/do';
import { share, delay, map, observable } from 'rxjs';
import { GlobalFunctionsService } from './global-functions.service';
// import { environment } from './../../environments/environment';
import { environment } from '../../environments/environment';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';


// Before version 4.3, the @angular/http module was used for making 
// HTTP requests in Angular applications. 
// The Angular team has now deprecated Http in version 5. 
// The HttpClient API from @angular/common/http package that shipped 
// in version 4.3 is now recommended for use in all apps. 

// old 
// import { Http, Headers, Response } from '@angular/http';
// new
// Usage:
import { HttpClientModule, HttpClient, HttpHeaders } from '@angular/common/http';
import { HotToastService } from '@ngneat/hot-toast';


@Injectable()
export class MysqlService {



  constructor(public _http: HttpClient,    public toastr: HotToastService,) {
  }

  // public addMysqlUserDatas(_firstname: string, _lastname: string) {
  //   const url = environment.php_apiURL_SSL + '/post_users.php';
  //   const headers = new Headers();
  //   headers.append('Content-Type', 'application/x-www-form-urlencoded');
  //   return this._http.post(url, {id: '', firstname: _firstname, lastname: _lastname})
  //     .map((res: Response) => res.text())
  //     .subscribe((res: any) => {
  //       console.log(res.toString());
  //     });
  // }

  public getMysqlUsersDatas() {
    return this._http.get(environment.php_apiURL_SSL + '/get_users.php')
    /*.do(x => console.log(x))**/
      .pipe(map((rep: any) => rep.json()));
  }

  // changed to a post to get model.
  public getMysqlUser(model: any, user_id: number) {
    return this._http.post(environment.php_apiURL_SSL + '/get_users.php?user_id=' + user_id, model)
    /*.do(x => console.log(x))**/
      // .pipe(map( (rep : any) => rep.json()));
      .pipe(map( (rep : any) => JSON.stringify(rep) ));
    }


  public getLocalUsersDatas() {
    return this._http.get('./assets/users.json')
    /* .do(x => console.log(x))**/
      .pipe(map( (rep : any) => rep.json()));
  }

  public getLocalTextDatas() {
    return this._http.get('./assets/read.txt')
    /* .do(x => console.log(x))**/
      .pipe(map( (rep : any) => rep.text()));
  }



// get pages cms.
public getMysqlPagesDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_pages.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}


// get pages cms. // Full page view
public getMysqlPageDatas(cms_id: any) {
  return this._http.get(environment.php_apiURL_SSL + '/get_page.php?cms_id=' + cms_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}









// get articles cms.
public getMysqlArticlesDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_articles.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}


// get article cms. // Full page view
public getMysqlArticleDatas(articles_id: any) {
  return this._http.get(environment.php_apiURL_SSL + '/get_article.php?articles_id=' + articles_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}


// get events cms.
public getMysqlEventsDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_events.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}

// get event cms. // Full page view
public getMysqlEventDatas(event_id: any) {
  return this._http.get(environment.php_apiURL_SSL + '/get_event.php?event_id=' + event_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}


// get jobs cms.
public getMysqlJobsDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_jobs.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}

// get job cms. // Full page view
public getMysqlJobDatas(job_id:any) {
  return this._http.get(environment.php_apiURL_SSL + '/get_job.php?job_id=' + job_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}



// get conferences cms.
public getMysqlConferencesDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_conferences.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}

// get conference cms. // Full page view
public getMysqlConferenceDatas(conference_id:any) {
  return this._http.get(environment.php_apiURL_SSL + '/get_conference.php?conference_id=' + conference_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}




// get conferences cms.
public getMysqlLinksDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_links.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}

// get conference cms. // Full page view
public getMysqlLinkDatas(link_id: any) {
  return this._http.get(environment.php_apiURL_SSL + '/get_link.php?link_id=' + link_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));
}



// get CorporateMembers cms.
public getMysqlCorporateMembersDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_corporate_members.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));

}


// Start of ATS mysql





// // get CorporateMembers cms.
// public getMysqlCorporateMembersDatas() {
//   return this._http.get(environment.php_apiURL_SSL + '/get_corporate_members.php')
//   /*.do(x => console.log(x))**/
//     .pipe(map( (rep : any) => rep.json()));

// }







// get pages cms. // Full page view
public templateDocxFileExistCheck(filename: any) {
  return this._http.get(environment.php_apiURL_SSL + '/docxTemplateFileExistsCheck.php?filename=' + filename)
  /*.do(x => console.log(x))**/
  // (res.toString()
    .pipe(map( (rep : any) => rep.json()));
}


// public templateDocxFileExistCheck(filename: any) {
// const url = environment.php_apiURL_SSL + '/docxTemplateFileExistsCheck.php?filename=' + filename;
// const headers = new Headers();
// headers.append('Content-Type', 'application/x-www-form-urlencoded');
// // console.log(p);
// return this._http.post(url, filename, {headers: headers})
//   .map((res: Response) => res.text())
//   .subscribe( (res: any)  => {
//     // console.log(res.toString());
//      console.log(rep => rep.json());
//   });
// }




// get Projects cms.
public getMysqlProjectsDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/get_projects.php')
  /*.do(x => console.log(x))**/
  //  console.log(res.toString());
  // rep => rep.json()
    .pipe(map( (rep : any) => rep.json()));

}






// MANAGER CALLS API
/* START OF NEW LOGIN FUNCTIONS AND SEPERATED MODULES */

// get Projects cms.
public getMysqlBrandsDatas() {
  return this._http.get(environment.php_apiURL_SSL + '/manager/get_brands.php')
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));

}


public addMysqlBrandDatas(model:any){
   // let body = JSON.stringify(b);
    console.log(model.name);
    return this._http.post(environment.php_apiURL_SSL + '/manager/create_brand.php', model);
    /// Maybe get the vars here and then rediect the page from the actual component.
}

public getMysqlBrandDatas(brand_id:any) {
  return this._http.get(environment.php_apiURL_SSL + '/manager/get_brand.php?brand_id=' + brand_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));

}


// public updateMysqlBrandDatas(b:any) {
//   const url = environment.php_apiURL_SSL + '/manager/update_brand.php';
//   const headers = new Headers();
//   headers.append('Content-Type', 'application/x-www-form-urlencoded');
//  // console.log(p);
//   return this._http.post<any>(url, b)
//     .map((res: Response) => res.text())
//     .subscribe( (res: any)  => {
//        console.log(res.toString());
//       // console.log(rep => rep.json());
//     });
// }


public getMysqlClientBrandsDatas(brand_id:any) {
  return this._http.get(environment.php_apiURL_SSL + '/manager/get_client_brands.php?brand_id=' + brand_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));

}



// deletes brand and all  trace, candidates, and client businesses
// - can be setup to clean everthig associated
// with the trace ID
deleteBrand(brand_id:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/delete_brand.php?brand_id='
   + brand_id);
}

deleteClientContact(id:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/delete_client_contact.php?id='
   + id);
}

deleteBrandClient(client_brand_id:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/delete_brand_client.php?client_brand_id='
   + client_brand_id);
}


deleteUser(user_id:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/delete_user.php?user_id='
   + user_id);
}


// STAR CLIENT

// get Traces cms. status
getCLIENTMysqlTracesStatusDatas(status:string, user_id:number, brand_id:number)
 {
  return this._http.get(environment.php_apiURL_SSL + '/get_traces_status_switch.php?status=' + status + '&user_id=' + user_id + '&brand_id=' + brand_id)
  /*.do(x => console.log(x))**/
    .pipe(map( (rep : any) => rep.json()));

}













deleteTraceFile(filename: string, trace_id: number) {
  return this._http.delete(environment.php_apiURL_SSL + '/fileDelete.php?filename='
   + filename + '&trace_id=' + trace_id);
}

deleteTraceCandidateFile(filename: any, trace_candidate_id:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/fileDelete.php?filename='
   + filename + '&trace_candidate_id=' + trace_candidate_id);
}


// sharmans

deleteJobFile(filename:any, job_id:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/fileDelete.php?filename='
   + filename + '&job_id=' + job_id);
}

// working on.
deleteJobFileAny(filename:any, job_id:any, file_make:any, file_server_location:any) {
  return this._http.delete(environment.php_apiURL_SSL + '/fileDelete.php?filename='
   + filename + '&job_id=' + job_id + '&file_make=' + file_make + '&file_server_location=' + file_server_location);
}

deleteThemeFile(filename: any) {
  return this._http.delete(environment.php_apiURL_SSL + '/fileThemeDelete.php?filename='
   + filename);
}


deleteDocxTemplateFile(filename: any) {
  return this._http.delete(environment.php_apiURL_SSL + '/fileDocxTemplateDelete.php?filename='
   + filename);
}



sendEmail(job_id:any, subject_id: any, user_id: any, model:any) {
   const url = environment.php_apiURL_SSL + '/sendEmailNote.php?job_id='
   + job_id + '&subject_id=' + subject_id + '&user_id=' + user_id;
   const headers = new Headers();
  headers.append('Content-Type', 'application/x-www-form-urlencoded, Access-Control-Allow-Origin: *');

 // console.log(p);

  return this._http.post(url, model)
  //  .map((res: Response) => res.text())
    .subscribe( (res: any)  => {
      console.log(res.toString());
      // console.log(rep => rep.json());
    }); /**/
}


// changed to send full model. not just subject ID>.... with already rendreed details Nov 2023
sendAgentUpdateEmail(subject_id:any, result) {
  const url = environment.php_apiURL_SSL + '/sendAgentUpdateEmail_test.php?subject_id='
  + subject_id;
  const headers = new Headers();
 headers.append('Content-Type', 'application/x-www-form-urlencoded, Access-Control-Allow-Origin: *');

// console.log(p);

// Error - Below was duplicating emails in PHP as I was sending headers and extra options! Yes Fixed!!
// Solution Found: https://stackoverflow.com/questions/41379992/angular-http-executed-twice-when-using-headers
// return this._http.post(url, subject_id, {headers: headers})
 return this._http.post(url, result)
//  return this._http.post(url, subject_id)
  // .map((res: Response) => res.text());
  // .pipe(
  //   this.toastr.observe({
  //     loading: 'Sending Emails...',
  //     success: '🚀.. ',
  //     error: '...😡 Error sending...' + subject_id
  //  })
  //  )
  .subscribe( (res: any)  => {
   // console.log(res.toString());
     // console.log(rep => rep.json());
  }); /**/
}



public createDocument(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/create_document.php', model)
   ;
   /// Maybe get the vars here and then rediect the page from the actual component.
}



public createDocument_2021Test(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/create_document_2021Test.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

createDocument_2023_Project(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/create_document_2023_Project.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

createDocument_2023_Paragraphs(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/create_document_2023_Paragraphs.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

public runSystemAutomation(log_model, model:any, system_automation_id){
  // let body = JSON.stringify(b);
  model.system_automation_id = system_automation_id;
   console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/runSystemAutomation_Dec2023.php?mergeJobData=', model);

    return this._http.post(environment.php_apiURL_SSL + '/runSystemAutomation.php?mergeJobData=', model);


    // return this._http.post(environment.php_apiURL_SSL + '/runSystemAutomation_TESTING.php?mergeJobData=', model);


   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}



public encryptSystemFile(model:any){
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/docx_encrypt.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public encryptSystemFileJustData(model:any){
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/docx_encrypt_just_data.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public encryptSystemFileGetPassword(model:any){
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/docx_encrypt_return_password.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public createDocument_PHPDocx(model:any) {
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/create_document_PHPDocx.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

public getHTMLforPHPdocx(model:any) {
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/viewHTML_document_PHPDocx.php?mergeJobData=', model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public removeHeadersFooters(model:any, file_name:any, template_name:any, subject_number:any) {
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/removeHeadersFooters_PHPDocx.php?mergeJobDat=&file_name=' + file_name + 
    '&template_name=' + template_name + '&subject_number=' + subject_number, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public addHeadersFooters2(model:any, file_name:any, template_name:any, subject_number:any) {
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/addHeadersFooters_PHPDocx2.php?mergeJobData=&file_name=' + file_name + 
    '&template_name=' + template_name + '&subject_number=' + subject_number, model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

public addHeadersFooters(model:any, file_name:any, template_name:any, subject_number: any) {
  model.is_theme = true;
  // let body = JSON.stringify(b);
    return this._http.post(environment.php_apiURL_SSL + '/addHeadersFooters_PHPDocx.php?mergeJobData=&file_name=' + file_name + 
    '&template_name=' + template_name + '&subject_number=' + subject_number, model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

// public createDocument_2021Test(model, mergeJobData){
//   // let body = JSON.stringify(b);
//    console.log(model.doc_id);
//     return this._http.post(environment.php_apiURL_SSL + '/create_document_2021Test.php?mergeJobData=' + mergeJobData, model);
//    // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
//    /// Maybe get the vars here and then rediect the page from the actual component.
// }




public createDocument_Invoice(model:any, invoice_id:number){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/create_document_invoice_Test.php?mergeJobData=&invoice_id=' + invoice_id, model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public createDocument_WorkOrder(model:any, work_order_id:number){
  // let body = JSON.stringify(b);
 //  console.log(model.doc_id);
    return this._http.post(environment.php_apiURL_SSL + '/create_document_work_order_Test.php?mergeJobData=&work_order_id=' + work_order_id, model);
   // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


// public createDocument_2021Test(model, mergeJobData){
//   // let body = JSON.stringify(b);
//    console.log(model.doc_id);
//     return this._http.post(environment.php_apiURL_SSL + '/create_document_2021Test.php?mergeJobData=' + mergeJobData, model);
//    // return this._http.post(environment.php_apiURL_SSL + '/test_send_vars.php?mergeJobData=' + mergeJobData, model);
//    /// Maybe get the vars here and then rediect the page from the actual component.
// }


public sendAgentInstructEmail(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   // return this._http.post(environment.php_apiURL_SSL + '/sendAgentInstructEmail.php', model);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

public sendAgentInstructEmailWithVars(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   // return this._http.post(environment.php_apiURL_SSL + '/sendAgentInstructEmail.php', model);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars.php', model); // was used for testing and now in live send mail.

   /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendAgentInstructEmailWithVarsWithReporting(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   // return this._http.post(environment.php_apiURL_SSL + '/sendAgentInstructEmail.php', model);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars_with_error_reporting.php', model); // was used for testing and now in live send mail.

   /// Maybe get the vars here and then rediect the page from the actual component.
}


public verifyUserSendResetRequest(model:any){
  // let body = JSON.stringify(b);
  //  console.log(model.doc_id);
   // return this._http.post(environment.php_apiURL_SSL + '/sendAgentInstructEmail.php', model);
   return this._http.post(environment.php_apiURL_SSL + '/verifyUserSendResetRequest.php', model);
}

public sendAgentCommunicationEmail(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars.php', model); // was used for testing and now in live send mail.

 // return this._http.post(environment.php_apiURL_SSL + '/sendAgentCommunicationEmail.php', model);
  // return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendAgentCommunicationEmailWithVars(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars.php', model); // was used for testing and now in live send mail.

 // return this._http.post(environment.php_apiURL_SSL + '/sendAgentCommunicationEmail.php', model);
  // return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendAgentCommunicationEmailWithVarsWithErrorReporting(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars_with_error_reporting.php', model); // was used for testing and now in live send mail.

 // return this._http.post(environment.php_apiURL_SSL + '/sendAgentCommunicationEmail.php', model);
  // return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendAgentCommunicationEmail_Original(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_original_2022.php', model);

 // return this._http.post(environment.php_apiURL_SSL + '/sendAgentCommunicationEmail.php', model);
  // return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}

public sendAffidavitCommunicationEmail(model:any){
  // let body = JSON.stringify(b);
//    console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   //   return this._http.post(environment.php_apiURL_SSL + '/sendAffidavitCommunicationEmail.php', model);
//  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
  /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendAffidavitCommunicationEmailWithVars(model:any){
  // let body = JSON.stringify(b);
//    console.log(model.doc_id);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars.php', model); // was used for testing and now in live send mail.

   //   return this._http.post(environment.php_apiURL_SSL + '/sendAffidavitCommunicationEmail.php', model);
//  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
  /// Maybe get the vars here and then rediect the page from the actual component.
}




public sendAffidavitCommunicationEmailWithVarsWithReporting(model:any){
  // let body = JSON.stringify(b);
//    console.log(model.doc_id);
  //  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails_with_vars_with_error_reporting.php', model); // was used for testing and now in live send mail.

   //   return this._http.post(environment.php_apiURL_SSL + '/sendAffidavitCommunicationEmail.php', model);
//  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
  /// Maybe get the vars here and then rediect the page from the actual component.
}



public sendClientAttServ(model:any){
  // let body = JSON.stringify(b);
  return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
//   console.log(model.doc_id);
 //   return this._http.post(environment.php_apiURL_SSL + '/sendClientAttServEmail.php', model);
  // return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendEmailWidget(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/sendEmailWidget.php', model);

 // return this._http.post(environment.php_apiURL_SSL + '/sendAgentCommunicationEmail.php', model);
  // return this._http.post(environment.php_apiURL_SSL + '/sendAllCommunicationEmails.php', model);
   /// Maybe get the vars here and then rediect the page from the actual component.
}


public sendSimpleEmail(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/sendEmailSimple.php', model);
}


public sendSimpleClientEmail(model:any){
  // let body = JSON.stringify(b);
   console.log(model.doc_id);
   return this._http.post(environment.php_apiURL_SSL + '/sendClientEmailSimple.php', model);
}


public sendWordTemplateViaFTP(model: any, filename:any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_word_template.php?filename=' + filename, model);
}

public sendWordTemplateViaFTP_Out(model: any, filename:any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_word_template_out.php?filename=' + filename, model);
}



// in
public sendWordThemeViaFTP(model: any, filename:any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_word_theme.php?filename=' + filename, model);
}

// out
public sendWordThemeViaFTP_Out(model: any, filename:any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_word_theme_out.php?filename=' + filename, model);
}

public sendDocumentCreatedViaFTP(model: any, filename:any, subject_number: any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_out_document_created.php?filename=' + filename + '&subject_number=' + subject_number, model);
}


public getDocumentCreatedViaFTP(model: any, filename:any, subject_number: any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_in_document_created.php?filename=' + filename + '&subject_number=' + subject_number, model);
}

public getUploadedDocumentCreatedViaFTP(model: any, filename:any, subject_number: any, job_id: any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_in_document_uploaded.php?filename=' + filename + '&subject_number=' + subject_number + '&job_id=' + job_id, model);
}


public sendUploadedDocumentCreatedViaFTP_Delete(model: any, filename:any, subject_number: any, job_id: any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_out_document_uploaded_delete.php?filename=' + filename + '&subject_number=' + subject_number + '&job_id=' + job_id, model);
}



public sendDocumentUploadedViaFTP(model: any, filename:any, subject_number: any, job_id){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_out_document_uploaded.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + job_id, model);
}


public sendDocumentUploadedViaFTP_AdobeAPI_Backvault(model: any, filename:any, subject_number: any, job_id){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/adobeAPI_ftp_out_document_uploaded.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + job_id, model);
}


public getDocumentUploadedViaFTP_AdobeAPI_Backvault(model: any, filename:any, subject_number: any, job_id){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/adobeAPI_ftp_in_document_uploaded.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + job_id, model);
}


public sendDocumentUploadedViaFTP_AdobeAPI_SO(model: any, filename:any, subject_number: any, job_id){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/adobeAPI_ftp_out_document_uploaded_SO.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + job_id, model);
}



public getDocumentUploadedViaFTP_AdobeAPI_SO(model: any, filename:any, subject_number: any, job_id){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/adobeAPI_ftp_in_document_uploaded_SO.php?filename=' + filename + '&subject_number=' + subject_number+ '&job_id=' + job_id, model);
}



public deleteUploadedDocumentCreatedViaFTP_AdobeAPI_Backvault(model: any, filename:any, subject_number: any, job_id: any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_out_document_uploaded_delete_AdobeAPI_Backvault.php?filename=' + filename + '&subject_number=' + subject_number + '&job_id=' + job_id, model);
}



public deleteUploadedDocumentCreatedViaFTP_AdobeAPI_SO(model: any, filename:any, subject_number: any, job_id: any){
  // let body = JSON.stringify(b);
   return this._http.post(environment.php_apiURL_SSL + '/tsaVM_ftp_out_document_uploaded_delete_AdobeAPI_SO.php?filename=' + filename + '&subject_number=' + subject_number + '&job_id=' + job_id, model);
}




}



